import React from 'react'

function RatingVersion(props) {
  const { dynamicListInfo, handleListData } = props

  return (
    <div>
      <div className='d-flex gap-1 align-items-end'>
        <div className='d-flex flex-column' style={{ width: '12rem' }}>
          {' '}
          <label>From rating(Number)</label>
          <input
            style={{ width: '10rem' }}
            placeholder='Enter From Rating'
            type={'number'}
            min='0'
            max='2'
            // options={ratings}
            value={dynamicListInfo.fromRatingV2}
            name='ratings'
            className='rounded'
            // classNamePrefix='select'
            onChange={e => handleListData('fromRatingV2', e.target.value)}
          />
        </div>
        <div className='d-flex flex-column ' style={{ width: '10rem' }}>
          <label>To rating(Number)</label>
          <input
            style={{ width: '10rem' }}
            placeholder='Enter To Rating'
            type={'number'}
            min='0'
            max='2'
            // options={ratings}
            value={dynamicListInfo.toRatingV2}
            name='ratings'
            className='rounded'
            // classNamePrefix='select'
            onChange={e => handleListData('toRatingV2', e.target.value)}
          />
        </div>
      </div>
      {!(dynamicListInfo.fromRatingV2 < dynamicListInfo.toRatingV2) && (
        <lable style={{ color: 'red', fontSize: '10px' }}>
          To rating must be greater than From rating
        </lable>
      )}
    </div>
  )
}

export default RatingVersion
